import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ScrollArea } from "@similarweb/ui-components";
import styled, { css } from "styled-components";

export const DropdownGroupItem = styled.div<{
    isActive: boolean;
    isSelectedInInput: boolean;
    isDisabled: boolean;
}>`
    display: flex;
    align-items: center;
    padding: 6px 16px;

    ${({ isActive }) =>
        isActive
            ? css`
                  background: ${colorsPalettes.blue[50]};
              `
            : null};
    ${({ isSelectedInInput }) => (isSelectedInInput ? `padding: 0;` : null)};
    ${({ isDisabled, isSelectedInInput }) =>
        isSelectedInInput
            ? null
            : isDisabled
              ? `cursor: not-allowed;`
              : `cursor: pointer;
                &:hover {
                    background: ${colorsPalettes.bluegrey[200]};
                }`};
`;

export const GroupWrapper = styled.div`
    display: flex;
`;

export const GroupTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 3px 0 0 10px;
`;

export const GroupContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
`;

export const GroupItemText = styled.p<{ isDisabled?: boolean }>`
    margin: 0;
    ${setFontVariant("input2")}
    ${({ isDisabled = false }) =>
        isDisabled ? `color: ${colorsPalettes.carbon[100]}` : `color: ${colorsPalettes.carbon[500]}`};
`;

export const GroupItemSubText = styled.p<{ isDisabled?: boolean }>`
    margin: 0;
    ${setFontVariant("listItem3")}
    ${({ isDisabled = false }) =>
        isDisabled ? `color: ${colorsPalettes.carbon[100]}` : `color: ${colorsPalettes.carbon[300]}`};
`;

export const DropdownSegmentItemWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 6px 16px;
    justify-content: space-between;
`;

export const DropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    border: 1px solid ${colorsPalettes.carbon[50]};
`;

export const SegmentsTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    max-width: 400px;
    justify-content: space-between;
`;

export const SelectedItemsCount = styled.span<{ isMaxReached: boolean }>`
    ${setFontVariant("subsectionTitle")}
    margin: 10px 0 20px 0;
    ${({ isMaxReached }) =>
        isMaxReached ? `color: ${colorsPalettes.red[400]}` : `color: ${colorsPalettes.carbon[400]}`}
`;

const ChangeNotAvaliableWrapper = styled.div`
    display: flex;
    padding: 10px 10px 10px 0;
    color: ${colorsPalettes.red[400]};
    align-items: center;
`;

const ChangeNotAvaliableText = styled.p`
    margin: 0 0 0 10px;
`;

export const DropdownWrapper = styled.div`
    display: flex;
`;

export const SegmentNameLabel = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const SegmentTypeBadge = styled.span`
    display: inline;
    padding: 3px 3px 3px;
    color: ${colorsPalettes.carbon[400]};
    background: ${colorsPalettes.carbon[50]};
    border-radius: 4px;
    font-size: 8px;
    line-height: 8px;
    text-transform: uppercase;
`;

export const TooltipPlaceholder = styled.span<{ isGroup: boolean }>`
    z-index: 10;
    right: 16px;
    top: 16px;

    ${({ isGroup }) => (isGroup ? null : "position: absolute;")}
`;

const GroupTooltipPlaceholder = styled.span`
    right: 16px;
    top: 16px;
`;

export const AutocompleteItemWrapper = styled.div`
    position: relative;
`;

export const SelectedItemsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0px 7px;
    padding: 2px 0 5px 0;
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
`;

export const SelectedSegemntsSrollWrapper = styled.div`
    display: flex;
`;

export const DropdownSelector = styled.div<{ isDisabled: boolean }>`
    width: 100%;
    .DropdownButton {
        border: unset;
        ${({ isDisabled }) =>
            isDisabled
                ? css`
                      background: ${colorsPalettes.carbon[25]};
                      cursor: not-allowed;
                  `
                : ""}
    }
`;

export const PopupWrapper = styled.div`
    position: relative;
`;

export const SegemntsScrollArea = styled(ScrollArea)`
    max-height: 130px;
    min-width: 400px;
`;
